import classNames from 'classnames/bind';
import { useField, useFormikContext } from 'formik';
import React from 'react';

import type { IInput } from './Input';
import { InputGroup } from './InputGroup';
import { ScrollToError } from '@containers/Form/ScrollToError/ScrollToError';

import styles from './Input.module.scss';
import ArrowTriangleDownIcon from '@icons/arrowTriangleDown.svg';

interface IProps extends IInput {
  name: string;
  disableErrorScroll?: boolean;
  tooltipText?: string;
  hideErrorOnBlur?: boolean;
  validate?: (value: string) => void;
  children: React.ReactNode;
}

const cx = classNames.bind(styles);

export const Select: React.FC<IProps> = ({
  id,
  name,
  label,
  className,
  optional,
  disableErrorScroll,
  required,
  testId,
  tooltipText,
  hideErrorOnBlur,
  validate,
  children,
}) => {
  const [field, meta] = useField<string>({ name, validate });
  const { errors, touched } = useFormikContext<{ [key: string]: string }>();
  const inputRef = React.useRef(null);

  return (
    <>
      {!disableErrorScroll && <ScrollToError inputRef={inputRef} name={name} />}
      <InputGroup
        error={meta.error}
        id={id}
        label={label}
        optional={optional}
        required={required}
        showError={hideErrorOnBlur ? meta.touched : true}
        showValidationIcon={false}
        testId={testId ?? name}
        tooltipText={tooltipText}
        touched={meta.touched}
        value={meta.value}
        isInput
      >
        <div className={styles.selectWrapper}>
          <select
            {...field}
            ref={inputRef}
            className={cx('input', className, { inputError: !!errors[name] && touched[name] })}
            id={id}
          >
            {children}
          </select>
          <ArrowTriangleDownIcon className={styles.arrow} />
        </div>
      </InputGroup>
    </>
  );
};
